<template lang="pug">
.content.beepoint-content
  .row.beepoint-body
    .col-md-12
      .header Lịch sử điểm BeePoint
      .card
        .card-content
          .col-md-6.box-content-left
            .form-group.box-grade
              label.control-label Lớp của bạn
              itemGrade(:grades='grades' @onGradeChange="onGradeChanged")
            .form-group.box-subject
              label.control-label Chọn môn học
              itemSubject(:subjects='subjects' @onSubjectChange="onSubjectChanged")
            .col-md-6.box-date-from
              .form-group
                label.control-label Từ ngày
                input.form-control(type='date', v-model="dateFrom")
            .col-md-6.box-date-to
              .form-group
                label.control-label Đến ngày
                input.form-control(type='date', v-model="dateTo")
            .col-md-12.box-btn-search
              button.btn.btn-search(@click.prevent='searchResult') Xem kết quả
          .col-md-6.box-content-right
            .title Thứ hạng hiện tại của bạn
            .form-group
              .box-level
                .box-item-level(v-for="br in beepointRank")
                  div
                    img(src="../../assets/images/point/Mask Group 32.svg" v-if="br.rank === 1")
                    img(src="../../assets/images/point/Mask Group 33.svg" v-else-if="br.rank === 2")
                    img(src="../../assets/images/point/Mask Group 34.svg" v-else-if="br.rank === 3")
                    img(:src="br.avatar ? br.avatar : require('../../assets/images/faces/ic_AvatarDefault.svg')")
                    span {{br.fullname}}
                    span.point-total {{formatNumber(br.amount_beepoint)}}
            .box-my-level
              .box-item-my-level
                div
                  .circle-level(v-if="rankUser && rankUser.rank") {{rankUser.rank}}
                  label(v-if="!rankUser")
                  img(:src="rankUser.avatar ? rankUser.avatar : require('../../assets/images/faces/ic_AvatarDefault.svg')")
                  span {{rankUser.fullname}}
                  span.point-total {{formatNumber(rankUser.amount_beepoint)}}
    .col-md-12
      .card(style='margin-top:0')
        .card-content
          .box-list-beepoint(v-if='!mobile')
            .box-beepoint-header
              span STT
              span Hoạt động
              span Ngày giờ
            .box-beepoint-scroll
              .box-beepoint-items(v-for="(o, index) in beepointList")
                span {{index + 1}}
                span Tham gia cuộc thi chung 
                  a.link-object(@click='onCompetition(index)') tên cuộc thi 
                | {{o.name.substring(39)}}
                span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }}
                span.minus(v-else) - {{ formatNumber(o.amount) }}
                |  điểm BeePoint
                span {{ o.created_at | moment }}
              observer(@intersect="onIntersected")
          .box-list-beepoint-kanban(v-else)
            .box-kanban-beepoint-default(v-if="beepointList && beepointList.length === 0")
              div CHƯA CÓ HOẠT ĐỘNG BEEPOINT
            .box-beepoint-scroll-kanban(v-if="beepointList && beepointList.length > 0")
              .box-kanban-beepoint(v-for="o in beepointList")
                div Tham gia cuộc thi chung 
                  a.link-object(@click='onCompetition(index)') tên cuộc thi 
                  | {{o.name.substring(39)}}
                  span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }}
                  span.minus(v-else) - {{ formatNumber(o.amount) }}
                  |  điểm BeePoint
                div {{ o.created_at | moment }}
              observer(@intersect="onIntersected")
          //- .box-beepoint-pagination
          //-   span PHÂN TRANG DANH SÁCH
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import itemGrade from '../UserProfile/itemGrade'
import itemSubject from '../UserProfile/itemSubject'
import Observer from '../Point/Observer'
import moment from 'moment'

export default {
  components: {
    itemGrade,
    itemSubject,
    Observer
  },
  data() {
    return {
      grades: null,
      subjects: null,
      beepointList: {
        type: Array,
        default: () => ([])
      },
      beepointRank: {
        type: Array,
        default: () => ([])
      },
      rankUser: {
        type: Object,
        default: () => ({})
      },
      items: [],
      points: [],
      offset: 10,
      limit: 10,
      grade_id: null,
      subject_id: null,
      dateFrom: null,
      dateTo: null,
      maxLengthSearch: 0,
      mobile: false
    }
  },
  methods: {
    onCompetition(index) {
      // console.log('competition: ', index)
    },
    onGradeChanged(id) {
      // console.log(id)
      this.grade_id = id
    },
    onSubjectChanged(id) {
      // console.log(id)
      this.subject_id = id
    },
    searchResult() {
      // console.log('xem ket qua', this.dateFrom, this.dateTo)
      if (this.grade_id !== null || this.subject_id !== null || (this.dateFrom !== '' && this.dateFrom !== null) || (this.dateTo !== '' && this.dateTo !== null)) {
        // console.log('IN', this.offset, this.limit)
        this.offset = 0
        this.limit = 10
        this.beepointList = []
        this.getBeepoints(0, 10)
        this.onIntersected()
      }
    },
    formatNumber(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getBeepoints(offset, limit) {
      await this.$apollo.query({
        query: gql(graphql.GET_POINTS_USER),
        variables: {
          uid: this.$store.getters.user,
          offset: offset,
          limit: limit,
          type: 1,
          grade_id: this.grade_id,
          subject_id: this.subject_id,
          date_from: this.dateFrom === undefined || this.dateFrom === '' ? null : this.dateFrom,
          date_to: this.dateTo === undefined || this.dateTo === '' ? null : this.dateTo
        }
      }).then((res) => {
        if (res) {
          // console.log('onIntersected: ', res.data.history_point)
          this.points = res.data.history_point
        }
      })
    },
    async onIntersected() {
      // console.log(this.offset, this.limit)
      await this.getBeepoints(this.offset, this.limit)
      this.offset += 10
      // console.log(this.beepointList)
      this.beepointList = [...this.beepointList, ...this.points]
    }
  },
  filters: {
    moment(date) {
      return moment(date).format('DD/MM/YYYY - hh:mm') // format (h:mm:ss a)
    }
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => data.grades
    },
    subjects: {
      query: gql(graphql.GET_SUBJECTS),
      update: data => data.subjects
    },
    beepointList: {
      query: gql(graphql.GET_POINTS_USER),
      variables() {
        return {
          uid: this.$store.getters.user,
          type: 1,
          offset: 0,
          limit: 10
        }
      },
      update: data => {
        if (data) return data.history_point
        else return null
      }
    },
    rankUser: {
      query: gql(graphql.GET_BEEPOINT_RANK_USER),
      variables() {
        return {
          uid: this.$store.getters.user
        }
      },
      update: data => data.v_beepoint[0],
      skip() {
        return this.$store.getters.user == null
      }
    },
    beepointRank: {
      query: gql(graphql.GET_BEEPOINT_TOP3),
      update: data => data.v_beepoint
    }
  },
  mounted() {
    if (window.innerWidth < 991) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  },
  created() {
    this.$store.commit('setIsHomePage', false)
  }
}
</script>
<style lang="scss">
.beepoint-content {
  padding-top: 20px !important;
}
.beepoint-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  .card {
    margin-top: 15px;
    margin-bottom: 15px;
    .card-content {
      .box-content-left {
        padding-left: 0px;
        padding-right: 10px;
        .box-grade,
        .box-subject {
          margin-top: 0;
        }
        .box-date-from {
          padding-left: 0;
          padding-right: 5px;
          .form-group {
            margin-top: 0;
          }
        }
        .box-date-to {
          padding-right: 0;
          padding-left: 5px;
          .form-group {
            margin-top: 0;
          }
        }
        .box-btn-search {
          padding-left: 0;
          padding-right: 0;
          margin-bottom: 10px;
          .btn-search {
            width: 100%;
            background-color: #FFD311;
            color: black;
            text-transform: none;
            font-family: 'adobe clean' sans-serif;
            font-size: 14px;
            margin-top: 5px;
          }
        }
      }
      .box-content-right {
        padding-left: 10px;
        padding-right: 0px;
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #343A40;
        }
        .form-group {
          margin-top: 30px;
          .box-level {
            .box-item-level {
              // border-top: 1px solid #EAEAEA; 
              padding: 10px 0px;
              &:last-child {
                border-bottom: 1px solid #EAEAEA;
              }
              div {
                width: 100%; 
                display:block; 
                color:#000;
              }
              img:first-child {width: 32px; height: 32px;}
              img:nth-child(2) {width:40px; height: 40px; margin-left: 20px; border-radius: 50%;}
              span{padding-left: 10px;}
              .point-total {float:right; display: block; z-index: 100; color: #9F6A28;font-size: 15px; font-weight: bold;padding-top: 10px;}
            }
          }
        }
        .box-my-level {
          padding-bottom: 7px;
          margin-top: 0px;
          .box-item-my-level {
            padding: 10px 0px 0px;
            div {
              width: 100%; 
              display:block; 
              color:#000;
              position: relative;
            }
            .circle-level {
              padding: 9px 10px; 
              text-align: center; 
              width: 35px !important; 
              height: 35px;
              border-radius: 50%;
              background-color: #FBF4D2;
              color: #9F6A28;
              display: inline-block;
              position: absolute;
              margin-top: 2px;
            }
            label {
              position: absolute;
              color: #9F6A28;
              padding: 10px 5px;
              border-bottom: 1px solid #9F6A28;
              margin-left: 13px;
            }
            img {width:40px; height: 40px; margin-left: 50px; border-radius: 50%;}
            span{padding-left: 10px;}
            .point-total {float:right; display: block; z-index: 100; color: #9F6A28;font-size: 15px; font-weight: bold;padding-top: 10px;}
          }
        }
      }
      .box-list-beepoint {
        .box-beepoint-header {
          padding: 10px 0;
          font-size: 15px;
          font-weight: bold;
          font-family: 'Helvetica' sans-serif;
          span:nth-child(2) {padding-left: 30px;}
          span:last-child {float:right;padding-right: 115px;}
        }
        .box-beepoint-scroll {
          overflow-y: scroll;
          height: 520px;
          &::-webkit-scrollbar {
            width: 10px;
	          background-color: #F5F5F5;
          }
          &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	          background-color: #F5F5F5;
	          border-radius: 10px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
	          // background-image: -webkit-gradient(linear,
						// 			   left bottom,
						// 			   left top,
						// 			   color-stop(0.44, rgb(122,153,217)),
						// 			   color-stop(0.72, rgb(73,125,189)),
						// 			   color-stop(0.86, rgb(28,58,148)));

            background-color: #F90;	
	          background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
											  transparent 25%,
											  transparent 50%,
											  rgba(255, 255, 255, .2) 50%,
											  rgba(255, 255, 255, .2) 75%,
											  transparent 75%,
											  transparent)
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555; 
          }
          .box-beepoint-items {
            border-top: 1px solid #00000029;
            padding: 20px 0 10px;
            position: relative;
            &:nth-last-child(1) {border-bottom: 1px solid #00000029;}
            span:first-child {position: absolute;}
            span:nth-child(2) {padding-left: 58px;
              a.link-object {color: #1A0DAB; cursor: pointer;}
            }
            span.plus {color: #3A9F00;}
            span.minus {color: #1A0DAB;}
            span:last-child {position: absolute; right: 48px;}
          }
        }
      }
      .box-beepoint-pagination {}
      .box-list-beepoint-kanban {
        .box-kanban-beepoint-default {display: none;}
        .box-kanban-beepoint {display:none;}
      }
    }
  }
}
@media (max-width: 414px) {
  .beepoint-content {
    padding-top: 30px !important;
  }
  .beepoint-body {
    .card {
      .card-content {
        .box-content-left {
          padding-left: 5px;
          padding-right: 5px;
          .box-date-from {
            padding-right: 0px;
          }
          .box-date-to {
            padding-left: 0px;
          }
        }
        .box-content-right {
          padding-left: 5px;
          padding-right: 5px;
          .title {
            margin-top: 20px;
          }
          .form-group {
            margin-top: 0px;
          }

        }
        .box-list-beepoint {
          .box-beepoint-header {display: none;}
          .box-beepoint-scroll {
            display: none;
          }
        }
        .box-list-beepoint-kanban {
          .box-kanban-beepoint-default {
            display: block;
            width: 100%;
            height: auto;
            font-weight: bold;
            background-color: #FAFAFA;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #E0E0E0;
            opacity: 1;
            font-size: 15px;
          }
          .box-beepoint-scroll-kanban {
            overflow-y: scroll;
            height: 300px;
            &::-webkit-scrollbar {
              width: 10px;
              background-color: #F5F5F5;
            }
            &::-webkit-scrollbar-track {
              -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
              background-color: #F5F5F5;
              border-radius: 10px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              // background-image: -webkit-gradient(linear,
              // 			   left bottom,
              // 			   left top,
              // 			   color-stop(0.44, rgb(122,153,217)),
              // 			   color-stop(0.72, rgb(73,125,189)),
              // 			   color-stop(0.86, rgb(28,58,148)));

              background-color: #F90;	
              background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
                          transparent 25%,
                          transparent 50%,
                          rgba(255, 255, 255, .2) 50%,
                          rgba(255, 255, 255, .2) 75%,
                          transparent 75%,
                          transparent)
            }

            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
              background: #555; 
            }
            .box-kanban-beepoint {
              display: block;
              width: 100%;
              height: auto;
              background-color: #FAFAFA;
              padding: 10px;
              border-radius: 5px;
              border: 1px solid #E0E0E0;
              opacity: 1;
              font-size: 15px;
              margin: 5px 0 10px;
              &:last-child {margin: 5px 0 5px;}
              div:first-child {
                padding-bottom: 5px;
                a.link-object {color: #1A0DAB;}
                span.plus {color: #3A9F00;}
                span.minus {color: #1A0DAB;}
              }
              div:nth-child(2) {color:#969FAD;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Beepoint.vue?39efba42